(function (Lfl, $, undefined) {
    /**
     * @memberOf Lfl
     */
    Lfl.Files = Lfl.Files || {};
     
    (function (Files, $, undefined) {
        if (Lfl.Files.isLoadedAlready(Lfl.Files, 'FileExtensionIconProvider')) {
            return;
        }

        /*
         |===============================================================================================================
         | Class definition
         |===============================================================================================================
         */

        /**
         * @param {object} parameters
         * @param {array} parameters.fileExtensionMappings
         * @param {string} parameters.defaultIcon
         *
         * @memberOf Lfl.Files
         * @lends Lfl.Files.FileExtensionIconProvider
         * @constructor
         */
        Lfl.Files.FileExtensionIconProvider = function (parameters) {

            var mappings = parameters.fileExtensionMappings;
            var extensionRegularExpression = /(?:\.([^.]+))?$/;
            /*
             |-----------------------------------------------------------------------------------------------------------
             | Construction
             |-----------------------------------------------------------------------------------------------------------
             */

            /*
             |-----------------------------------------------------------------------------------------------------------
             | Public methods
             |-----------------------------------------------------------------------------------------------------------
             */

            
            /**
             * Get icon defined for file's extension, or default, if none matches
             */      
            this.getIconFromFileName = function (fileName) {
                var fileExtension = getFileExtension(fileName);
                if (typeof fileExtension === 'undefined') {
                    return parameters.defaultIcon;
                }

                for (var key in mappings) {
                    if (fileExtension === key) {
                        if (mappings.hasOwnProperty(key)) {
                            return mappings[key];
                        }
                    }
                }

                return parameters.defaultIcon;
            };

            /*
             |-----------------------------------------------------------------------------------------------------------
             | Private methods
             |-----------------------------------------------------------------------------------------------------------
             */

            function getFileExtension (fileName) {
                return extensionRegularExpression.exec(fileName)[1];
            }

        };
    }(Lfl.Files, jQuery));
}(window.Lfl = window.Lfl || {}, jQuery));